/**
 * @generated SignedSource<<e422fe8b74f0d2efc97e8840d5f57bc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type vtoEditorProvidersQuery$variables = Record<PropertyKey, never>;
export type vtoEditorProvidersQuery$data = {
  readonly tryOnProviders: {
    readonly list: ReadonlyArray<{
      readonly key: number;
      readonly value: number;
    }>;
  };
};
export type vtoEditorProvidersQuery = {
  response: vtoEditorProvidersQuery$data;
  variables: vtoEditorProvidersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TryOnProvidersTypesList",
    "kind": "LinkedField",
    "name": "tryOnProviders",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfInt32AndInt64",
        "kind": "LinkedField",
        "name": "list",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "vtoEditorProvidersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "vtoEditorProvidersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ac28d670cf773a0b6737e017cfa99620",
    "id": null,
    "metadata": {},
    "name": "vtoEditorProvidersQuery",
    "operationKind": "query",
    "text": "query vtoEditorProvidersQuery {\n  tryOnProviders {\n    list {\n      key\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "64092549a45ce54cd028ac60a6d3ae9b";

export default node;
